import { frontHost } from '~/utils/host';

export const cardPaymentSettingsPayload = async (
  tenderTypeId: string,
  paymentAmount: number,
  planID?: string,
) => {
  const { proto, host } = await frontHost();
  return {
    cardPaymentAcceptSettings: {
      HostPageOrigin: `${proto}://${host}`,
      AdaptorPath: `${proto}://${host}/Connectors`,
      CardPaymentEnabled: false,
      CardTokenizationEnabled: true,
      HideBillingAddress: true,
      TenderTypeId: tenderTypeId,
      PaymentAmount: paymentAmount,
      RequireShippingAddress: true,
    },
    extensionProperties: planID
      ? [{ Key: 'PlanID', Value: { StringValue: planID } }]
      : [],
  };
};
